export const APP_VERSION = process.env.REACT_APP_VERSION;
export const APP_NAME = process.env.REACT_APP_TITLE;
export const ENABLE_REDUX_DEV_TOOLS = process.env.REACT_APP_ENABLE_REDUX_DEV_TOOLS;
export const THEMES = {
    LIGHT: 'LIGHT',
    ONE_DARK: 'ONE_DARK',
    UNICORN: 'UNICORN'
};
